export const DATA = {
	INITIALIZE: 'DATA_INITIALIZE',
	POST: 'DATA_POST',
	DELETE: 'DATA_DELETE',
};

export const REQ = {
	INITIALIZE: 'REQ_INITIALIZE',
	POST: 'REQ_POST',
	DELETE: 'REQ_DELETE',
};

export const AUTH = {
	INITIALIZE: 'AUTH_INITIALIZE',
	AUTHENTICATE: 'AUTHENTICATE',
	REFRESH: 'REFRESH',
	LOGOUT: 'LOGOUT',
	SET_FAILED_AUTO_LOGIN: 'SET_FAILED_AUTO_LOGIN',
	SET_FAILED_AUTO_REFRESH: 'SET_FAILED_AUTO_REFRESH',
};

export const BODY_SITE = {
	INITIALIZE: 'BODY_SITE_INITIALIZE',
	GET_PAGE: 'BODY_SITE_GET_PAGE',
	GET_EXISTING_PAGE: 'BODY_SITE_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'BODY_SITE_CLEAR_PAGES',
	CLEAR_ITEM: 'BODY_SITE_CLEAR_ITEM',
	GET: 'BODY_SITE_GET',
	SET_ACTIVE: 'BODY_SITE_SET_ACTIVE',
	POST: 'BODY_SITE_POST',
	PUT: 'BODY_SITE_PUT',
	DELETE: 'BODY_SITE_DELETE',
};

export const BODY_SITE_ANNOTATION = {
	INITIALIZE: 'BODY_SITE_ANNOTATION_INITIALIZE',
	GET_PAGE: 'BODY_SITE_ANNOTATION_GET_PAGE',
	GET_EXISTING_PAGE: 'BODY_SITE_ANNOTATION_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'BODY_SITE_ANNOTATION_CLEAR_PAGES',
	CLEAR_ITEM: 'BODY_SITE_ANNOTATION_CLEAR_ITEM',
	GET: 'BODY_SITE_ANNOTATION_GET',
	SET_ACTIVE: 'BODY_SITE_ANNOTATION_SET_ACTIVE',
	POST: 'BODY_SITE_ANNOTATION_POST',
	PUT: 'BODY_SITE_ANNOTATION_PUT',
	DELETE: 'BODY_SITE_ANNOTATION_DELETE',
};

export const CONDITION = {
	INITIALIZE: 'CONDITION_INITIALIZE',
	GET_PAGE: 'CONDITION_GET_PAGE',
	GET_EXISTING_PAGE: 'CONDITION_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'CONDITION_CLEAR_PAGES',
	CLEAR_ITEM: 'CONDITION_CLEAR_ITEM',
	GET: 'CONDITION_GET',
	SET_ACTIVE: 'CONDITION_SET_ACTIVE',
	POST: 'CONDITION_POST',
	PUT: 'CONDITION_PUT',
	DELETE: 'CONDITION_DELETE',
};

export const CONDITION_ANNOTATION = {
	INITIALIZE: 'CONDITION_ANNOTATION_INITIALIZE',
	GET_PAGE: 'CONDITION_ANNOTATION_GET_PAGE',
	GET_EXISTING_PAGE: 'CONDITION_ANNOTATION_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'CONDITION_ANNOTATION_CLEAR_PAGES',
	CLEAR_ITEM: 'CONDITION_ANNOTATION_CLEAR_ITEM',
	GET: 'CONDITION_ANNOTATION_GET',
	SET_ACTIVE: 'CONDITION_ANNOTATION_SET_ACTIVE',
	POST: 'CONDITION_ANNOTATION_POST',
	PUT: 'CONDITION_ANNOTATION_PUT',
	DELETE: 'CONDITION_ANNOTATION_DELETE',
};

export const EOC = {
	INITIALIZE: 'EOC_INITIALIZE',
	GET_PAGE: 'EOC_GET_PAGE',
	GET_EXISTING_PAGE: 'EOC_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'EOC_CLEAR_PAGES',
	CLEAR_ITEM: 'EOC_CLEAR_ITEM',
	GET: 'EOC_GET',
	SET_ACTIVE: 'EOC_SET_ACTIVE',
	POST: 'EOC_POST',
	PUT: 'EOC_PUT',
	DELETE: 'EOC_DELETE',
};

export const IMAGE = {
	INITIALIZE: 'IMAGE_INITIALIZE',
	GET_PAGE: 'IMAGE_SET_IMAGE_GET_PAGE',
	GET_EXISTING_PAGE: 'IMAGE_SET_IMAGE_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'IMAGE_SET_IMAGE_CLEAR_PAGES',
	CLEAR_ITEM: 'IMAGE_SET_IMAGE_CLEAR_ITEM',
	GET: 'IMAGE_SET_IMAGE_GET',
	SET_ACTIVE: 'IMAGE_SET_IMAGE_SET_ACTIVE',
	POST: 'IMAGE_SET_IMAGE_POST',
	PUT: 'IMAGE_SET_IMAGE_PUT',
	DELETE: 'IMAGE_SET_IMAGE_DELETE',
};

export const IMAGE_SET = {
	INITIALIZE: 'IMAGE_SET_INITIALIZE',
	GET_PAGE: 'IMAGE_SET_GET_PAGE',
	GET_EXISTING_PAGE: 'IMAGE_SET_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'IMAGE_SET_CLEAR_PAGES',
	CLEAR_ITEM: 'IMAGE_SET_CLEAR_ITEM',
	GET: 'IMAGE_SET_GET',
	SET_ACTIVE: 'IMAGE_SET_SET_ACTIVE',
	POST: 'IMAGE_SET_POST',
	PUT: 'IMAGE_SET_PUT',
	DELETE: 'IMAGE_SET_DELETE',
};

export const IMAGE_ANNOTATION = {
	INITIALIZE: 'IMAGE_ANNOTATION_INITIALIZE',
	GET_PAGE: 'IMAGE_ANNOTATION_GET_PAGE',
	GET_EXISTING_PAGE: 'IMAGE_ANNOTATION_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'IMAGE_ANNOTATION_CLEAR_PAGES',
	CLEAR_ITEM: 'IMAGE_ANNOTATION_CLEAR_ITEM',
	GET: 'IMAGE_ANNOTATION_GET',
	SET_ACTIVE: 'IMAGE_ANNOTATION_SET_ACTIVE',
	POST: 'IMAGE_ANNOTATION_POST',
	PUT: 'IMAGE_ANNOTATION_PUT',
	DELETE: 'IMAGE_ANNOTATION_DELETE',
};


export const GLOBALS = {
	INITIALIZE: 'GLOBALS_INITIALIZE',
	IS_LOADING: 'GLOBALS_IS_LOADING',
	IS_PAGE_SCROLL: 'GLOBALS_IS_PAGE_SCROLL',
	IS_LANDSCAPE: 'GLOBALS_IS_LANDSCAPE',
	IS_MOBILE_BROWSER: 'GLOBALS_IS_MOBILE_BROWSER',
	DEAD_END: 'GLOBALS_DEAD_END',
};

export const MESSAGE = {
	INITIALIZE: 'MESSAGE_INITIALIZE',
	GET_PAGE: 'MESSAGE_GET_PAGE',
	GET_EXISTING_PAGE: 'MESSAGE_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'MESSAGE_CLEAR_PAGES',
	CLEAR_ITEM: 'MESSAGE_CLEAR_ITEM',
	GET: 'MESSAGE_GET',
	SET_ACTIVE: 'MESSAGE_SET_ACTIVE',
	POST: 'MESSAGE_POST',
	PUT: 'MESSAGE_PUT',
	DELETE: 'MESSAGE_DELETE'
};

export const ORG = {
	INITIALIZE: 'ORG_INITIALIZE',
	GET_PAGE: 'ORG_GET_PAGE',
	GET_EXISTING_PAGE: 'ORG_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'ORG_CLEAR_PAGES',
	CLEAR_ITEM: 'ORG_CLEAR_ITEM',
	GET: 'ORG_GET',
	SET_ACTIVE: 'ORG_SET_ACTIVE',
	POST: 'ORG_POST',
	PUT: 'ORG_PUT',
	DELETE: 'ORG_DELETE',
};

export const PRIVATE_CHANNEL = {
	INITIALIZE: 'PRIVATE_CHANNEL_INITIALIZE',
	GET_PAGE: 'PRIVATE_CHANNEL_GET_PAGE',
	GET_EXISTING_PAGE: 'PRIVATE_CHANNEL_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'PRIVATE_CHANNEL_CLEAR_PAGES',
	CLEAR_ITEM: 'PRIVATE_CHANNEL_CLEAR_ITEM',
	GET: 'PRIVATE_CHANNEL_GET',
	SET_ACTIVE: 'PRIVATE_CHANNEL_SET_ACTIVE',
	UNSET_ACTIVE: 'PRIVATE_CHANNEL_UNSET_ACTIVE',
	POST: 'PRIVATE_CHANNEL_POST',
	PUT: 'PRIVATE_CHANNEL_PUT',
	POST_INVITE_USER_TO: 'PRIVATE_CHANNEL_POST_INVITE_USER_TO',
	DELETE_USER_FROM: 'PRIVATE_CHANNEL_DELETE_USER_FROM',
};

export const PUBLIC_CHANNEL = {
	INITIALIZE: 'PUBLIC_CHANNEL_INITIALIZE',
	GET_PAGE: 'PUBLIC_CHANNEL_GET_PAGE',
	GET_EXISTING_PAGE: 'PUBLIC_CHANNEL_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'PUBLIC_CHANNEL_CLEAR_PAGES',
	CLEAR_ITEM: 'PUBLIC_CHANNEL_CLEAR_ITEM',
	GET: 'PUBLIC_CHANNEL_GET',
	SET_ACTIVE: 'PUBLIC_CHANNEL_SET_ACTIVE',
	UNSET_ACTIVE: 'PUBLIC_CHANNEL_UNSET_ACTIVE',
	POST: 'PUBLIC_CHANNEL_POST',
	PUT: 'PUBLIC_CHANNEL_PUT',
	POST_INVITE_USER_TO: 'PUBLIC_CHANNEL_POST_INVITE_USER_TO',
	DELETE_USER_FROM: 'PUBLIC_CHANNEL_DELETE_USER_FROM',
};

export const QUERY = {
	INITIALIZE: 'QUERY_INITIALIZE',
	GET_PAGE: 'QUERY_GET_PAGE',
	GET_EXISTING_PAGE: 'QUERY_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'QUERY_CLEAR_PAGES',
	CLEAR_ITEM: 'QUERY_CLEAR_ITEM',
	GET: 'QUERY_GET',
	SET_ACTIVE: 'QUERY_SET_ACTIVE',
	POST: 'QUERY_POST',
	PUT: 'QUERY_PUT',
	DELETE: 'QUERY_DELETE',
};

export const USER = {
	INITIALIZE: 'USER_INITIALIZE',
	GET_PAGE: 'USER_GET_PAGE',
	GET_EXISTING_PAGE: 'USER_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'USER_CLEAR_PAGES',
	CLEAR_ITEM: 'USER_CLEAR_ITEM',
	GET: 'USER_GET',
	SET_ACTIVE: 'USER_SET_ACTIVE',
	POST: 'USER_POST',
	PUT: 'USER_PUT',
	DELETE: 'USER_DELETE',
};

export const SEARCH_USER = {
	INITIALIZE: 'SEARCH_USER_INITIALIZE',
	GET_PAGE: 'SEARCH_USER_GET_PAGE',
	GET_EXISTING_PAGE: 'SEARCH_USER_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'SEARCH_USER_CLEAR_PAGES',
	CLEAR_ITEM: 'SEARCH_USER_CLEAR_ITEM',
	GET: 'SEARCH_USER_GET',
	SET_ACTIVE: 'SEARCH_USER_SET_ACTIVE',
	POST: 'SEARCH_USER_POST',
	PUT: 'SEARCH_USER_PUT',
	DELETE: 'SEARCH_USER_DELETE',
};

export const WORKSPACE = {
	INITIALIZE: 'WORKSPACE_INITIALIZE',
	GET_PAGE: 'WORKSPACE_GET_PAGE',
	GET_EXISTING_PAGE: 'WORKSPACE_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'WORKSPACE_CLEAR_PAGES',
	CLEAR_ITEM: 'WORKSPACE_CLEAR_ITEM',
	GET: 'WORKSPACE_GET',
	SET_ACTIVE: 'WORKSPACE_SET_ACTIVE',
	POST: 'WORKSPACE_POST',
	PUT: 'WORKSPACE_PUT',
	POST_INVITE_USER_TO: 'WORKSPACE_POST_INVITE_USER_TO',
	DELETE_USER_FROM: 'WORKSPACE_DELETE_USER_FROM',
};

export const ACCOUNT_SETTING = {
	INITIALIZE: 'ACCOUNT_SETTING_INITIALIZE',
	GET_PAGE: 'ACCOUNT_SETTING_GET_PAGE',
	GET_EXISTING_PAGE: 'ACCOUNT_SETTING_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'ACCOUNT_SETTING_CLEAR_PAGES',
	CLEAR_ITEM: 'ACCOUNT_SETTING_CLEAR_ITEM',
	GET: 'ACCOUNT_SETTING_GET',
	SET_ACTIVE: 'ACCOUNT_SETTING_SET_ACTIVE',
	POST: 'ACCOUNT_SETTING_POST',
	PUT: 'ACCOUNT_SETTING_PUT',
	DELETE: 'ACCOUNT_SETTING_DELETE',
};

export const PROFILE_PICTURE = {
	INITIALIZE: 'PROFILE_PICTURE_INITIALIZE',
	GET_PAGE: 'PROFILE_PICTURE_GET_PAGE',
	GET_EXISTING_PAGE: 'PROFILE_PICTURE_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'PROFILE_PICTURE_CLEAR_PAGES',
	CLEAR_ITEM: 'PROFILE_PICTURE_CLEAR_ITEM',
	GET: 'PROFILE_PICTURE_GET',
	SET_ACTIVE: 'PROFILE_PICTURE_SET_ACTIVE',
	POST: 'PROFILE_PICTURE_POST',
	PUT: 'PROFILE_PICTURE_PUT',
	DELETE: 'PROFILE_PICTURE_DELETE',
};

export const WS = {
	INITIALIZE: 'WS_INITIALIZE',
	CONNECT: 'WS_CONNECT',
	CLOSE: 'WS_CLOSE',
	TIMEOUT: 'WS_TIMEOUT',
};

export const WEBRTC = {
	INITIALIZE: 'WEBRTC_INITIALIZE',
	POST: 'WEBRTC_POST',
	DELETE: 'WEBRTC_DELETE',
};

export const HEARTBEAT = {
	INITIALIZE: 'HEARTBEAT_INITIALIZE',
	SET: 'HEARTBEAT_SET',
	CLEAR: 'HEARTBEAT_CLEAR',
};

export const WEBRTC_USER = {
	INITIALIZE: 'WEBRTC_USER_INITIALIZE',
	GET_PAGE: 'WEBRTC_USER_GET_PAGE',
	CLEAR_PAGES: 'WEBRTC_USER_CLEAR_PAGES',
	POST: 'WEBRTC_USER_POST',
	DELETE: 'WEBRTC_USER_DELETE',
};

export const TEAM = {
	INITIALIZE: 'TEAM_INITIALIZE',
	GET_PAGE: 'TEAM_GET_PAGE',
	GET_EXISTING_PAGE: 'TEAM_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'TEAM_CLEAR_PAGES',
	CLEAR_ITEM: 'TEAM_CLEAR_ITEM',
	GET: 'TEAM_GET',
	SET_ACTIVE: 'TEAM_SET_ACTIVE',
	POST: 'TEAM_POST',
	PUT: 'TEAM_PUT',
	DELETE: 'TEAM_DELETE',
};

export const SEARCH_TEAM = {
	INITIALIZE: 'SEARCH_TEAM_INITIALIZE',
	GET_PAGE: 'SEARCH_TEAM_GET_PAGE',
	GET_EXISTING_PAGE: 'SEARCH_TEAM_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'SEARCH_TEAM_CLEAR_PAGES',
	CLEAR_ITEM: 'SEARCH_TEAM_CLEAR_ITEM',
	GET: 'SEARCH_TEAM_GET',
	SET_ACTIVE: 'SEARCH_TEAM_SET_ACTIVE',
	POST: 'SEARCH_TEAM_POST',
	PUT: 'SEARCH_TEAM_PUT',
	DELETE: 'SEARCH_TEAM_DELETE',
};


export const CONFERENCE_ROOM = {
	INITIALIZE: 'CONFERENCE_ROOM_INITIALIZE',
	POST: 'CONFERENCE_ROOM_POST',
	DELETE: 'CONFERENCE_ROOM_DELETE',
};

export const CONFERENCE_ROOM_USER = {
	INITIALIZE: 'CONFERENCE_ROOM_USER_INITIALIZE',
	GET_PAGE: 'CONFERENCE_ROOM_USER_GET_PAGE',
	CLEAR_PAGES: 'CONFERENCE_ROOM_USER_CLEAR_PAGES',
	POST: 'CONFERENCE_ROOM_USER_POST',
	DELETE: 'CONFERENCE_ROOM_USER_DELETE',
};

export const NOTIFICATION = {
	INITIALIZE: 'NOTIFICATION_INITIALIZE',
	GET_PAGE: 'NOTIFICATION_GET_PAGE',
	GET_EXISTING_PAGE: 'NOTIFICATION_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'NOTIFICATION_CLEAR_PAGES',
	CLEAR_ITEM: 'NOTIFICATION_CLEAR_ITEM',
	GET: 'NOTIFICATION_GET',
	SET_ACTIVE: 'NOTIFICATION_SET_ACTIVE',
	POST: 'NOTIFICATION_POST',
	PUT: 'NOTIFICATION_PUT',
	DELETE: 'NOTIFICATION_DELETE',
};

export const LIBRARY = {
	INITIALIZE: 'LIBRARY_INITIALIZE',
	GET_PAGE: 'LIBRARY_GET_PAGE',
	GET_EXISTING_PAGE: 'LIBRARY_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'LIBRARY_CLEAR_PAGES',
	CLEAR_ITEM: 'LIBRARY_CLEAR_ITEM',
	GET: 'LIBRARY_GET',
	SET_ACTIVE: 'LIBRARY_SET_ACTIVE',
	POST: 'LIBRARY_POST',
	PUT: 'LIBRARY_PUT',
	DELETE: 'LIBRARY_DELETE',
};

export const PAGE = {
	INITIALIZE: 'PAGE_INITIALIZE',
	GET_PAGE: 'PAGE_GET_PAGE',
	GET_EXISTING_PAGE: 'PAGE_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'PAGE_CLEAR_PAGES',
	CLEAR_ITEM: 'PAGE_CLEAR_ITEM',
	GET: 'PAGE_GET',
	SET_ACTIVE: 'PAGE_SET_ACTIVE',
	POST: 'PAGE_POST',
	PUT: 'PAGE_PUT',
	DELETE: 'PAGE_DELETE',
};

export const SEARCH_PAGE = {
	INITIALIZE: 'SEARCH_PAGE_INITIALIZE',
	GET_PAGE: 'SEARCH_PAGE_GET_PAGE',
	GET_EXISTING_PAGE: 'SEARCH_PAGE_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'SEARCH_PAGE_CLEAR_PAGES',
	CLEAR_ITEM: 'SEARCH_PAGE_CLEAR_ITEM',
	GET: 'SEARCH_PAGE_GET',
	SET_ACTIVE: 'SEARCH_PAGE_SET_ACTIVE',
	POST: 'SEARCH_PAGE_POST',
	PUT: 'SEARCH_PAGE_PUT',
	DELETE: 'SEARCH_PAGE_DELETE',
};

export const BOOK = {
	INITIALIZE: 'BOOK_INITIALIZE',
	GET_PAGE: 'BOOK_GET_PAGE',
	GET_EXISTING_PAGE: 'BOOK_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'BOOK_CLEAR_PAGES',
	CLEAR_ITEM: 'BOOK_CLEAR_ITEM',
	GET: 'BOOK_GET',
	SET_ACTIVE: 'BOOK_SET_ACTIVE',
	POST: 'BOOK_POST',
	PUT: 'BOOK_PUT',
	DELETE: 'BOOK_DELETE',
};

export const SEARCH_BOOK = {
	INITIALIZE: 'SEARCH_BOOK_INITIALIZE',
	GET_PAGE: 'SEARCH_BOOK_GET_PAGE',
	GET_EXISTING_PAGE: 'SEARCH_BOOK_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'SEARCH_BOOK_CLEAR_PAGES',
	CLEAR_ITEM: 'SEARCH_BOOK_CLEAR_ITEM',
	GET: 'SEARCH_BOOK_GET',
	SET_ACTIVE: 'SEARCH_BOOK_SET_ACTIVE',
	POST: 'SEARCH_BOOK_POST',
	PUT: 'SEARCH_BOOK_PUT',
	DELETE: 'SEARCH_BOOK_DELETE',
};

export const BRANDING = {
	INITIALIZE: 'BRANDING_INITIALIZE',
	GET_PAGE: 'BRANDING_GET_PAGE',
	GET_EXISTING_PAGE: 'BRANDING_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'BRANDING_CLEAR_PAGES',
	CLEAR_ITEM: 'BRANDING_CLEAR_ITEM',
	GET: 'BRANDING_GET',
	SET_ACTIVE: 'BRANDING_SET_ACTIVE',
	POST: 'BRANDING_POST',
	PUT: 'BRANDING_PUT',
	DELETE: 'BRANDING_DELETE',
};

export const ORG_CONFIG = {
	INITIALIZE: 'ORG_CONFIG_INITIALIZE',
	GET_PAGE: 'ORG_CONFIG_GET_PAGE',
	GET_EXISTING_PAGE: 'ORG_CONFIG_GET_EXISTING_PAGE',
	CLEAR_PAGES: 'ORG_CONFIG_CLEAR_PAGES',
	CLEAR_ITEM: 'ORG_CONFIG_CLEAR_ITEM',
	GET: 'ORG_CONFIG_GET',
	SET_ACTIVE: 'ORG_CONFIG_SET_ACTIVE',
	POST: 'ORG_CONFIG_POST',
	PUT: 'ORG_CONFIG_PUT',
	DELETE: 'ORG_CONFIG_DELETE',
};

export const CONFERENCE_ROOM_TRANSCRIPT = {
	INITIALIZE:  'CONFERENCE_ROOM_TRANSCRIPT_INITIALIZE',
	GET_PAGE:  'CONFERENCE_ROOM_TRANSCRIPT_GET_PAGE',
	GET_EXISTING_PAGE:  'CONFERENCE_ROOM_TRANSCRIPT_GET_EXISTING_PAGE',
	CLEAR_PAGES:  'CONFERENCE_ROOM_TRANSCRIPT_CLEAR_PAGES',
	CLEAR_ITEM:  'CONFERENCE_ROOM_TRANSCRIPT_CLEAR_ITEM',
	GET:  'CONFERENCE_ROOM_TRANSCRIPT_GET',
	SET_ACTIVE:  'CONFERENCE_ROOM_TRANSCRIPT_SET_ACTIVE',
	POST:  'CONFERENCE_ROOM_TRANSCRIPT_POST',
	PUT:  'CONFERENCE_ROOM_TRANSCRIPT_PUT',
	DELETE:  'CONFERENCE_ROOM_TRANSCRIPT_DELETE',
};

export const EOC_EXPORT_RECORD = {
	INITIALIZE:  'EOC_EXPORT_RECORD_INITIALIZE',
	GET_PAGE:  'EOC_EXPORT_RECORD_GET_PAGE',
	GET_EXISTING_PAGE:  'EOC_EXPORT_RECORD_GET_EXISTING_PAGE',
	CLEAR_PAGES:  'EOC_EXPORT_RECORD_CLEAR_PAGES',
	CLEAR_ITEM:  'EOC_EXPORT_RECORD_CLEAR_ITEM',
	GET:  'EOC_EXPORT_RECORD_GET',
	SET_ACTIVE:  'EOC_EXPORT_RECORD_SET_ACTIVE',
	POST:  'EOC_EXPORT_RECORD_POST',
	PUT:  'EOC_EXPORT_RECORD_PUT',
	DELETE:  'EOC_EXPORT_RECORD_DELETE',
};